import { apiClient } from '@/provider';
import { prepareSchema } from '@/provider/utils';
import monitoringItemScheme from './monitoring-item.graphql';
import monitoringItemListScheme from './monitoring-item-list.graphql';

const SCHEME_NAME_PREFIX = 'PixelMonitor Object Item, ';
const addNamePrefix = name => `${SCHEME_NAME_PREFIX}${name}`;

export default {
  fetchBaseMonitoringItemSchemaId() {
    return apiClient
      .query({
        query: monitoringItemScheme.fetchBaseMonitoringItemSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: monitoringItemScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareSchema(res.data.schema);
  },

  async list({ parentSchemaId }) {
    const res = await apiClient.query({
      query: monitoringItemListScheme.load,
      variables: {
        parentSchemaId
      },
      fetchPolicy: 'no-cache'
    });
    return res.data.schemata.map(i => prepareSchema(i));
  },

  create({ name, schemaId, parentSchemaId }) {
    return apiClient
      .mutate({
        mutation: monitoringItemScheme.create,
        variables: {
          input: {
            newSchemaName: addNamePrefix(name),
            schemaId,
            newSchemaTags: ['application', 'monitor', 'object monitoring item'],
            linkToSchemaId: parentSchemaId
          }
        }
      })
      .then(r => r.data?.createSchemaCopy?.uuid);
  },

  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: monitoringItemScheme.update,
      variables: {
        id,
        name: addNamePrefix(name),
        description
      }
    });
  }
};
